import { render, staticRenderFns } from "./DeclaracaoVinculoModal.vue?vue&type=template&id=02b5dfca&"
import script from "./DeclaracaoVinculoModal.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoVinculoModal.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoVinculoModal.vue?vue&type=style&index=0&id=02b5dfca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports